export default "__VITE_ASSET__7lu06K$n__"